<template>
  <div class="input-multi-search">
    <BFormInput placeholder="szukaj" v-model="search" @keydown.native="keyDown" autofocus />
    <span class="input-group-btn">
      <div class="search-select-button" @click="openSelectedButton = !openSelectedButton">
        <div class="button">
          <span class="selected-type">{{selectedType.name}}</span>
          <chevron-down-icon v-if="!openSelectedButton" title />
          <chevron-up-icon v-if="openSelectedButton" title />
        </div>

        <div class="dropdown-button-menu" :class="{'open': openSelectedButton}">
          <ul>
            <li v-for="type in types" @click="selectedType=type">{{type.name}}</li>
          </ul>
        </div>
      </div>

      <button class="btn btn-default" type="submit" @click="searchPhrase">
        <magnify-icon title="Szukaj..." />
      </button>
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BFormInput } from "bootstrap-vue/esm/components/form-input/form-input";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
import ChevronUpIcon from "vue-material-design-icons/ChevronUp.vue";

export default {
  components: { BFormInput, MagnifyIcon, ChevronDownIcon, ChevronUpIcon },
  props: ["types", "selectedType"],
  data() {
    return {
      openSelectedButton: false,
      search: ""
      // selectedType: this.types[0]
    };
  },
  computed: {
    ...mapState({
      pr: state => state.search.phrase,
      prType: state => state.search.phraseType
    })
  },
  methods: {
    searchPhrase() {
      // this.$store.dispatch("closeSearchBlock");
      this.$store.dispatch("search/findByPhraseCondition", {
        phrase: this.search,
        type: this.selectedType.type
      });
      this.$router.replace({ name: "searchPage" });
    },
    keyDown(evt) {
      if (evt.which == 13) {
        this.searchPhrase();
      }
    }
  },
  watch: {
    pr: function(value) {
      this.search = value;
    },
    prType: function(value) {
      let type = this.types.find(t => t.type == value);
      if (type) {
        this.selectedType = type;
      }
    }
  },
  mounted() {
    console.log(this.selectedType);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/src/input/SearchMultiInput.vue